import React, {useEffect, useState} from 'react';
import {Wordmark} from '../../ui/index.js';

// The bisponsor.com red stage over every onboarding step (Kaan, 5 Kasım 2026, seçenek C; pano docs/ux-2026-11-05/onboarding-gorsel).
// The glass objects come from the site (Blender renders); the microphone and the cup are rendered on the stage red itself,
// so they only ever sit on the stage. Every image here is decorative: the stage carries no text a screen reader needs.
// Versioned folder: the server caches public files for a year without a content hash, so a changed render gets a new number.
const BASE='/sahne/1/';
const ART={
 mic:{src:'mikrofon.webp',width:480,height:695},cup:{src:'kupa.webp',width:560,height:515},
 ticket:{src:'bilet.webp',width:640,height:370},rings:{src:'halka.webp',width:640,height:468},arc:{src:'kavis.webp',width:640,height:409},
};
// One object per form step, so moving forward feels like moving through the site's scenes.
const STEP_ART={website:'arc',brand:'rings',goals:'ticket',priority:'ticket',followup:'arc',preferences:'rings',matches:'ticket',contact:'rings',code:'arc',meeting:'rings'};

// The waiting cup turns like the site's hero objects: 36 frames, one turn in about 2.5 seconds.
const FRAMES=36,FRAME_MS=70,frameSrc=i=>`${BASE}kupa/kupa-${String(i).padStart(2,'0')}.webp`;
let frames=null;
/** Starts loading the turning cup before the first wait (called on the website step), so no frame is missing mid-turn. */
export function preloadCup(){
 if(frames||typeof Image==='undefined')return;
 frames=Array.from({length:FRAMES},(_,i)=>{const image=new Image();image.decoding='async';image.src=frameSrc(i);return image;});
}
function TurningCup(){
 const [index,setIndex]=useState(0);
 useEffect(()=>{
  if(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches)return;
  preloadCup();
  let raf=0,last=0,current=0;
  // Only step onto a frame the browser already has, so a slow network pauses the turn instead of flashing an empty box.
  const tick=time=>{if(time-last>=FRAME_MS){const next=(current+1)%FRAMES;if(frames[next].complete&&frames[next].naturalWidth){current=next;setIndex(next);}last=time;}raf=requestAnimationFrame(tick);};
  raf=requestAnimationFrame(tick);
  return()=>cancelAnimationFrame(raf);
 },[]);
 return <img className="onboarding-stage-turning" src={frameSrc(index)} alt="" width="440" height="405" decoding="async"/>;
}
const Art=({name,className})=>{const a=ART[name];return <img className={`onboarding-stage-object ${className}`} src={BASE+a.src} alt="" width={a.width} height={a.height} decoding="async"/>;};

/** The wordmark goes back to bisponsor.com, where every visitor to this page came from (Kaan, 5 Kasım 2026). */
export function HomeLink({language}){
 return <a className="onboarding-home" href="https://bisponsor.com/" aria-label={language==='en'?'BiSponsor home page':'BiSponsor ana sayfası'}><Wordmark/></a>;
}

/** kind: welcome | step | waiting | plan | booked. The top bar (wordmark and language) is passed in and sits on the stage. */
export function Stage({kind,step,topbar}){
 return <div className="onboarding-stage" data-kind={kind}>
  {topbar}
  <div className="onboarding-stage-art" aria-hidden="true">
   {kind==='welcome'&&<><Art name="mic" className="onboarding-stage-left"/><Art name="cup" className="onboarding-stage-right"/></>}
   {kind==='step'&&<Art name={STEP_ART[step]||'ticket'} className="onboarding-stage-corner"/>}
   {kind==='plan'&&<Art name="cup" className="onboarding-stage-center"/>}
   {kind==='booked'&&<Art name="rings" className="onboarding-stage-center"/>}
   {kind==='waiting'&&<TurningCup/>}
  </div>
 </div>;
}

// "Ekibimizin birlikte çalıştığı markalar": the strip from bisponsor.com (13 logos, equal optical size from --h, grey until hovered).
// Logo use is Kaan's responsibility (site decision, 5 Kasım 2026).
const LOGOS=[['english-home','English Home',132,13,15],['dhl','DHL',1118,160,19],['dp-world','DP World',145,33,23],['ea-sports-fifa','EA Sports FIFA',406,160,28],['yandex-go','Yandex Go',151,36,24],
 ['spotify','Spotify',161,43,25],['culinary-arts','Culinary Arts Commission',139,65,35],['rolls-royce','Rolls-Royce',139,160,42],['okx','OKX',288,81,20],['vision-2030','Vision 2030',89,59,40],
 ['lg','LG',114,51,33],['opera','Opera',437,160,30],['airasia','AirAsia',316,160,33]];
export function LogoStrip({title}){
 return <section className="onboarding-logos" aria-label={title}><p>{title}</p>
  <div className="onboarding-logos-row">{LOGOS.map(([file,name,width,height,h])=><img key={file} src={`${BASE}markalar/${file}.webp`} alt={name} width={width} height={height} loading="lazy" decoding="async" style={{'--h':h}}/>)}</div>
 </section>;
}
